/* Shared cart rules for the temporary Mono personaliser. */
window.HBPersonalisationFee = {
  buildItems(product, feeVariantId, linkId, productTitle) {
    if (!Number.isSafeInteger(feeVariantId) || feeVariantId <= 0) {
      throw new Error('Personalisation is temporarily unavailable. Please try again later.');
    }
    if (!Number.isSafeInteger(product.id) || !Number.isSafeInteger(product.quantity) || product.quantity < 1) {
      throw new Error('Please select a size and a quantity of at least one.');
    }
    const count = Number(product.properties._hb_personalisation_count || 1);
    if (!Number.isSafeInteger(count) || count < 1) throw new Error('Invalid personalisation count.');
    const properties = { ...product.properties, _hb_personalisation_id: linkId };
    return [
      { ...product, properties },
      {
        id: feeVariantId,
        quantity: product.quantity * count,
        parent_id: product.id,
        properties: {
          For: productTitle,
          Text: properties['Personalisation Text'] || properties.Text,
          Font: properties.Font,
          Colour: properties['Thread Colour'] || properties.Colour,
          Position: properties.Placement || properties.Position,
          _hb_personalisation_id: linkId,
          _hb_personalisation_fee: 'true',
          _hb_personalisation_count: String(count)
        }
      }
    ];
  },

  syncUpdates(updates, lines) {
    const parentQuantities = new Map();
    lines.filter((line) => line.linkId && !line.isFee).forEach((parent) => {
      if (Object.prototype.hasOwnProperty.call(updates, parent.key)) {
        parentQuantities.set(parent.linkId,
          (parentQuantities.get(parent.linkId) || 0) + Number(updates[parent.key]));
      }
    });
    lines.filter((line) => line.isFee).forEach((fee) => {
      if (parentQuantities.has(fee.linkId)) {
        updates[fee.key] = String(parentQuantities.get(fee.linkId) * Number(fee.count || 1));
      }
    });
    return updates;
  }
};
